import React, { useEffect, useRef, useState } from "react";
import { fetchCommunitylist } from "../services/Communitylist";
import { API_BASE } from "../api/apiConfig";

const Communitylist = () => {
  const [community, setcommunity] = useState([]);
  const [activeCountry, setActiveCountry] = useState("All");
  const [activeCity, setActiveCity] = useState("All");
  const sliderRef = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    const loadData = async () => {
      const res = await fetchCommunitylist();
      if (res?.status && Array.isArray(res.data)) {
        setcommunity(res.data);
      }
    };
    loadData();
  }, []);


   /* ================= HELPERS ================= */
  const parseCategories = (category) => {
    if (!category) return [];
    try {
      const parsed = JSON.parse(category);
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  };

  /* ================= FILTER DATA ================= */

  const countries = [
    "All",
    ...new Set(community.map((m) => m.country).filter(Boolean)),
  ];

  const cities = [
    "All",
    ...new Set(
      community
        .filter(
          (m) => activeCountry === "All" || m.country === activeCountry
        )
        .map((m) => m.city)
        .filter(Boolean)
    ),
  ];

  const filteredcommunity = community.filter((m) => {
      if (activeCountry !== "All" && m.country !== activeCountry) return false;
      if (activeCity !== "All" && m.city !== activeCity) return false;

      if (
        searchTerm &&
        !m.city?.toLowerCase().includes(searchTerm.toLowerCase())
      ) {
        return false;
      }

      return true;
    });


  /* ================= SLIDER SCROLL ================= */

  const scrollSlider = (dir) => {
    if (!sliderRef.current) return;
    sliderRef.current.scrollBy({
      left: dir === "next" ? 350 : -350,
      behavior: "smooth",
    });
  };

  return (
   
    <>

   <div className="sticky top-0 z-10 bg-white border-b border-slate-200 px-4 py-3">
        <div className="relative">
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={24}
            height={24}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="lucide lucide-search absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-slate-400"
        >
            <circle cx={11} cy={11} r={8} />
            <path d="m21 21-4.3-4.3" />
        </svg>
        <input
            placeholder="Search cities..."
            className="w-full h-10 pl-10 pr-4 rounded-lg border border-slate-300 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:border-transparent text-sm"
            type="text" value={searchTerm} onChange={(e) => setSearchTerm(e.target.value)}
        />
        </div>
    </div>

  <div className="px-4 py-4 space-y-4">
        
    {filteredcommunity.map((item, i) => (
        <a className="block" href={`/CommunityDtl/${item.id}`}>
        <div className="relative overflow-hidden rounded-xl shadow-md hover:shadow-lg transition-shadow">
            <div className="relative h-40">
            <img
                alt={item.city}
                className="w-full h-full object-cover"
                src={
                  item.image
                    ? `${API_BASE}${item.image}`
                    : `${API_BASE}default.jpg`
                }
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/20 to-transparent" />
            <div className="absolute top-3 right-3 px-2 py-1 bg-orange-500 text-white text-xs font-medium rounded-full">
                🔥 Trending
            </div>
            {/*<div className="absolute top-3 left-3 px-2 py-1 bg-teal-500 text-white text-xs font-medium rounded-full">
                Capital Hub
            </div>*/}
            <h3 className="absolute bottom-3 left-3 text-xl font-bold text-white">
                {item.city}
            </h3>
            </div>
            <div className="bg-white p-3 grid grid-cols-2 gap-2">
            <div className="text-center">
                <p className="text-xs text-slate-500">Members</p>
                <p className="text-sm font-semibold text-slate-900">{item.community_members}</p>
            </div>
            <div className="text-center border-l border-slate-200">
                <p className="text-xs text-slate-500">Meetups</p>
                <p className="text-sm font-semibold text-teal-600">{item.monthly_meetups}</p>
            </div>
            </div>
        </div>
        </a>
    ))}

    </div>

    </>

  );
};

export default Communitylist;
